import { getRequestEmailThreads } from '../../../../api'
import { FILE_SCOPE_REQUEST } from '../../../../constants/file'
import { useOutboundUuid } from '../../../../hooks'
import { EmailAttachedThreadsModal } from '../../../Email'
import {
  getAttachedEmailThreads,
  getEmailThreadsFromResponse,
} from '../../Task.utils'

export function useTaskTableItemAttachedEmailThreads({
  renderThreadModal,
  onCloseModal,
  onSetModal,
}) {
  const outboundUuid = useOutboundUuid()

  function getHandleLoadAttachedEmailThreads(requestId, activityId) {
    return (_, params) =>
      getRequestEmailThreads(
        requestId,
        {
          ...params,
          activity: activityId,
        },
        { outboundUuid }
      )
  }

  function handleClickEmailTag({ itemId, objectId }) {
    onSetModal(
      <EmailAttachedThreadsModal
        readonly
        attachedFilesProps={{ scope: FILE_SCOPE_REQUEST, subject: objectId }}
        entityId={objectId}
        getAttachedEmailThreads={getAttachedEmailThreads}
        getItemsFromResponse={getEmailThreadsFromResponse}
        headerProps={{ text: 'Modal.EmailAttachedThreadsTitleKey' }}
        loadItems={getHandleLoadAttachedEmailThreads(objectId, itemId)}
        renderThreadModal={renderThreadModal}
        onClose={onCloseModal}
      />
    )
  }

  return { handleClickEmailTag }
}
